import { HOTELS_PATH } from 'config';

/**
 * Strips the Next.js basePath from a pathname to prevent duplication
 * when using router.push() with connected-next-router
 *
 * @param {string} pathname - The full pathname including basePath
 * @returns {string} - The pathname without the basePath
 */
export const stripBasePath = (pathname) => {
  if (!pathname || typeof pathname !== 'string') {
    return pathname;
  }

  // If the pathname starts with the basePath, remove it
  if (pathname.startsWith(HOTELS_PATH)) {
    return pathname.slice(HOTELS_PATH.length) || '/';
  }

  return pathname;
};

export default stripBasePath;
